import { RainbowBorderButton } from "./RainbowBorderButton";
import { jsx as _jsx } from "react/jsx-runtime";
export function MintDonationButton(_ref) {
  let {
    disabled = false,
    onClick = () => null
  } = _ref;
  return /*#__PURE__*/_jsx(RainbowBorderButton, {
    disabled: disabled,
    onClick: onClick,
    "data-testid": "mint-donation-button",
    children: "Mint donation"
  });
}